// extracted by mini-css-extract-plugin
export default {"discoverFirstVisit":"DiscoverFirstVisit_discoverFirstVisit__2iYV1","buttonSection":"DiscoverFirstVisit_buttonSection__ZoRjs"};